.head {
  margin: 4px 4px 0;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: -0.01em;
}

.intro {
  margin: 0 4px;
  color: var(--muted);
  font-size: 14px;
  line-height: 1.4;
}

.status {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 14px 16px;
  background: var(--surface);
  border: 1px solid var(--card-border);
  border-radius: var(--r-lg);
  font-size: 14px;
  line-height: 1.4;
}

.bad {
  border-color: var(--danger);
}

.line {
  display: flex;
  justify-content: space-between;
  gap: 12px;
}

.line > span:first-child {
  color: var(--muted);
}

.warn {
  margin: 0;
  color: var(--danger);
  font-size: 13px;
}

.steps {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 0;
  padding: 16px 16px 16px 34px;
  background: var(--surface);
  border: 1px solid var(--card-border);
  border-radius: var(--r-lg);
  font-size: 14px;
  line-height: 1.45;
  color: var(--ink-soft);
}

.steps b {
  color: var(--ink);
}

.link {
  color: var(--accent);
  text-decoration: underline;
}

.support {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
